import { createReducer } from "@reduxjs/toolkit";
import {
  getNotification,
  getNotificationCount,
  getNotificationCountFailure,
  getNotificationCountSuccess,
  getNotificationFailure,
  getNotificationPortion,
  getNotificationPortionFailure,
  getNotificationPortionSuccess,
  getNotificationSuccess,
  hideNotification,
  hideNotificationFailure,
  hideNotificationSuccess,
  newNotificationReceivedSuccess,
  notificationReceive,
  readNotifications,
  readNotificationsFailure,
  readNotificationsSuccess,
} from "./actions";
import { deleteItemFromArray } from "@helpers/common";

const initialState = {
  allNotifications: [],
  notificationsById: {},
  totalCount: undefined,
  count: undefined,
  newNotificationCount: undefined,
  isLoading: false,
  isSuccess: false,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(notificationReceive.type, (state, action) => ({
      ...state,
      isLoading: true,
      isSuccess: false,
      ...action.payload,
      count: 0,
    }))
    .addCase(getNotification.type, (state, action) => ({
      ...state,
      isLoading: true,
      isSuccess: false,
      ...action.payload,
    }))
    .addCase(getNotificationSuccess.type, (state, action) => ({
      ...state,
      ...action.payload,
      isLoading: false,
      isSuccess: true,
    }))
    .addCase(getNotificationFailure.type, (state, action) => ({
      ...state,
      isLoading: false,
      isSuccess: false,
      error: action.payload,
    }))
    .addCase(getNotificationPortion.type, (state, action) => ({
      ...state,
      isLoading: true,
      ...action.payload,
    }))
    .addCase(getNotificationPortionSuccess.type, (state, { payload }) => {
      const { allNotifications, notificationsById } = state;
      const {
        allNotifications: newNotifications,
        notificationsById: newNotificationsById,
        totalCount,
      } = payload;

      return {
        ...state,
        allNotifications: [...allNotifications, ...newNotifications],
        notificationsById: { ...notificationsById, ...newNotificationsById },
        totalCount,
        error: initialState.error,
        isLoading: false,
      };
    })
    .addCase(getNotificationPortionFailure.type, (state, action) => ({
      ...state,
      isLoading: false,
      error: action.payload,
    }))
    .addCase(getNotificationCount.type, (state, action) => ({
      ...state,
      isLoading: true,
      isSuccess: false,
      ...action.payload,
    }))
    .addCase(getNotificationCountSuccess.type, (state, action) => ({
      ...state,
      ...action.payload,
      isLoading: false,
      isSuccess: true,
    }))
    .addCase(getNotificationCountFailure.type, (state, action) => ({
      ...state,
      isLoading: false,
      isSuccess: false,
      error: action.payload,
    }))
    .addCase(hideNotification.type, (state, action) => ({
      ...state,
      isLoading: true,
      ...action.payload,
    }))
    .addCase(hideNotificationSuccess.type, (state, { payload }) => ({
      ...state,
      isLoading: false,
      isSuccess: true,
      allNotifications: deleteItemFromArray(state.allNotifications, payload),
    }))
    .addCase(hideNotificationFailure.type, (state, action) => ({
      ...state,
      isLoading: false,
      isSuccess: false,
      error: action.payload,
    }))
    .addCase(readNotifications.type, (state, action) => ({
      ...state,
      isLoading: true,
      isSuccess: false,
      ...action.payload,
    }))
    .addCase(readNotificationsSuccess.type, (state, action) => ({
      ...state,
      ...action.payload,
      isLoading: false,
      isSuccess: true,
      count: 0,
      newNotificationCount: 0,
    }))
    .addCase(readNotificationsFailure.type, (state, action) => ({
      ...state,
      isLoading: false,
      isSuccess: false,
      error: action.payload,
    }))
    .addCase(newNotificationReceivedSuccess.type, (state, { payload }) => {
      const { notificationsById, allNotifications } = payload;
      const id = allNotifications[0];

      state.notificationsById[id] = notificationsById[id];
      state.allNotifications.unshift(id);
    });
});
